(function () {
    'use strict';

    angular
    .module('szallodak-houserules', ['daterangepicker']);
})();
